import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table table-responsive-md border border-gray overflow-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Payable"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Time"),
    /*#__PURE__*/_createElementVNode("th", null, "End Date"),
    /*#__PURE__*/_createElementVNode("th", null, "End Time"),
    /*#__PURE__*/_createElementVNode("th", null, "Units"),
    /*#__PURE__*/_createElementVNode("th", null, "Rate"),
    /*#__PURE__*/_createElementVNode("th", null, "Rate Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Paid"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "table-error"
}
const _hoisted_7 = { colspan: "10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Error", -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h6", null, "There was a problem while getting Payroll Task Shifts. Please try again.", -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" If the problem persists, click "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://help.axxessweb.com/openid/login/1",
    target: "_blank"
  }, "here"),
  /*#__PURE__*/_createTextVNode(" to report it. ")
], -1 /* HOISTED */)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableEmpty = _resolveComponent("TableEmpty")!
  const _component_PayrollDetailsRow = _resolveComponent("PayrollDetailsRow")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      (!_ctx.hasPayrollDetails)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
            (_ctx.payrollDetailsLoading)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: i,
                    class: "table-loading"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                      return (_openBlock(), _createElementBlock("td", { key: i }, _hoisted_5))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                  _createElementVNode("td", _hoisted_7, [
                    _hoisted_8,
                    _hoisted_9,
                    _createElementVNode("button", {
                      class: "btn btn-primary mb-3",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getPayrollDetails()))
                    }, "Try Again"),
                    _hoisted_10
                  ])
                ]))
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode("Empty Table"),
      (_ctx.hasPayrollDetails && _ctx.payrollDetails.length == 0 && _ctx.newDetail.length == 0)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
            _createVNode(_component_TableEmpty, {
              "col-span": _ctx.columns,
              component: _ctx.diagnoses,
              "secondary-message": "No Payroll Detail Found"
            }, null, 8 /* PROPS */, ["col-span", "component"])
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode("Existing Details"),
      (_ctx.hasPayrollDetails)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payrollDetails, (detail) => {
              return (_openBlock(), _createBlock(_component_PayrollDetailsRow, {
                detail: detail,
                id: _ctx.id,
                "snapshot-view": _ctx.snapshotView
              }, null, 8 /* PROPS */, ["detail", "id", "snapshot-view"]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode("New Details"),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newDetail, (detail, index) => {
          return (_openBlock(), _createBlock(_component_PayrollDetailsRow, {
            detail: detail,
            "is-add-requested": true,
            "save-new-detail": _ctx.saveNewDetail,
            show: _ctx.newDetail.length > 0,
            "cancel-save-new-detail": _ctx.cancelSaveNewDetail,
            "is-new-terminal": _ctx.isNewTerminal,
            "snapshot-view": _ctx.snapshotView
          }, null, 8 /* PROPS */, ["detail", "save-new-detail", "show", "cancel-save-new-detail", "is-new-terminal", "snapshot-view"]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ])
  ]))
}